var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRouterStandard = function SvgRouterStandard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#fabc3c",
    d: "M20 2a18 18 0 100 36 18 18 0 100-36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.78 19.16l-1.42 1.42a7.282 7.282 0 01-1.79-2.94l1.94-.49a5.346 5.346 0 001.27 2.01zM19 14l-4-4-4 4h3.02a14.98 14.98 0 00.19 2.17l1.94-.49a13.215 13.215 0 01-.13-1.68zm10 0l-4-4-4 4h2.99c-.1 3.68-1.28 4.75-2.54 5.88A8.672 8.672 0 0020 21.43a7.133 7.133 0 00-1.13-1.24l-1.41 1.41A3.874 3.874 0 0119 25v5h2v-5a4.055 4.055 0 011.79-3.63c1.38-1.24 3.08-2.78 3.2-7.37z",
    fill: "#fabc3c"
  })));
};
export default SvgRouterStandard;